module.exports = __webpack_public_path__ + "static/media/dog.f0aa3cf2.png";